/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { paymentToken, vaultCardAdd, vaultCardAudit, vaultCardDefault, vaultCardDelete, vaultCardVerify, vaultPayPalAccount } from '../settings/apiconfig';
import interfaceService from './interfaceService';
import { getBuyerHeaders, getBuyersUrl } from 'shared/http';


class PaymentServices {

    constructor() {
        this.service = interfaceService.getService();
    }
    

    addVaultCard(data) {
        return this.service.post(getBuyersUrl(vaultCardAdd), JSON.stringify(data), getBuyerHeaders());
    }

    deleteVaultCard(data) {
        return this.service.delete(getBuyersUrl(vaultCardDelete), getBuyerHeaders(true, 'json', data));
    }

    defaultVaultCard(data) {
        return this.service.put(getBuyersUrl(vaultCardDefault), JSON.stringify(data), getBuyerHeaders());
    }

    getPaymentToken() {
        return this.service.get(getBuyersUrl(paymentToken), getBuyerHeaders());
    }

    auditVaultCard(data) {
        return this.service.post(getBuyersUrl(vaultCardAudit), JSON.stringify(data), getBuyerHeaders());
    }

    vaultPayPalAccount(data) {
        return this.service.post(getBuyersUrl(vaultPayPalAccount), JSON.stringify(data), getBuyerHeaders());
    }

    vaultCardVerify(data) {
        return this.service.post(getBuyersUrl(vaultCardVerify), JSON.stringify(data), getBuyerHeaders());
    }
}

export default new PaymentServices();